import simbApi from ".";
import { ITEM_VIEW_DISCREPANCY } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export const fetchItemDiscrepancy = async (access_token: string, currentItemId: string, linkedBoards: any) => {
  try {
    const response = await simbApi.post(
      ITEM_VIEW_DISCREPANCY,
      {
        currentItemId,
        linkedBoards,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response?.data?.data;
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};
